<template>
  <div class="vacancies-tab" v-if="titleMetaData">
    <div class="header">
      <div class="header__top">
        <Button
          hasLeftIcon
          buttonColor="white"
          srcColor="grey"
          :iconSrc="titleIconScr"
          :buttonText="titleButtonText"
          :iconColor="titleIconColor"
          :class="[
            'header__button',
            $route.meta.module == 'HRPAC_CANDIDATES' && this.stages.length
              ? 'candidate-stages'
              : 'vacancy-stages'
          ]"
          buttonSize="big"
          @click="closePanel"
        />
        <p
          :class="[
            'header-title__text',
            'header__text',
            $route.meta.module == 'HRPAC_CANDIDATES' && this.stages.length
              ? 'candidate-stages'
              : 'vacancy-stages'
          ]"
        >
          {{ titleButtonText }}
        </p>
        <div v-if="titleSecondary" class="header__secondary">
          <Picture
            v-if="titleSecondaryIcon"
            :url="titleSecondaryIcon"
            class="header__icon"
          />
          <p class="header__text">{{ titleSecondaryText }}</p>
        </div>
      </div>

      <Subpanel
        v-if="titleTabs"
        :tabs="titleTabs"
        module="RightPanel"
        class="header__subpanels"
      />
    </div>
    <VacancySteps v-if="mode == 'canditateStagePanel' && !loading" />
    <Vacancies v-else-if="mode == 'canditatePanel' && !loading" />
  </div>
</template>

<script>
import { store } from '@/store';
import Vacancies from 'Elements/Sidebar/Vacancies';
import VacancySteps from 'Elements/Sidebar/VacancySteps';
import Button from 'Elements/Button/Button';
import Subpanel from 'Elements/Subpanel/Subpanel';
import Picture from 'Elements/Picture/Picture';

export default {
  created() {
    if (!localStorage.getItem('currentVacancyUserId')) {
      store.dispatch('rightPanel/getMetadata', {
        intentOrRequest: {
          url: '/index.php?module=HRPAC_SELECTION_STAGE_CANDIDATES_1&action=get_RightPanel',
          request_params: {
            candidate_id: this.$route.params.id,
            content_type: 'cand_card'
          }
        },
        newCheck: false
      });
    }
  },
  computed: {
    titleIcon() {
      return store.state.rightPanel.panelMode == 'canditatePanel'
        ? 'MenuLeft'
        : 'FullArrowLeft';
    },
    titleIconScr() {
      return store.state.rightPanel.metadata?.title?.main[0]?.icon || '';
    },
    titleIconColor() {
      return store.state.rightPanel.metadata?.title?.main[0]?.color || '';
    },
    titleButtonText() {
      return store.state.rightPanel.metadata?.title?.main[0]?.lbl.value || '';
    },
    titleMetaData() {
      return store.state.rightPanel.metadata?.title || null;
    },
    titleSecondary() {
      return store.state.rightPanel.metadata?.title?.secondary || null;
    },
    titleSecondaryIcon() {
      return store.state.rightPanel.metadata.title?.secondary[0]?.icon || '';
    },
    titleSecondaryText() {
      return (
        store.state.rightPanel.metadata.title?.secondary[0]?.lbl.value || ''
      );
    },
    mode() {
      return store.state.rightPanel.panelMode || '';
    },
    stages() {
      return store.state.rightPanel.panelMode == 'canditateStagePanel'
        ? store.state.rightPanel.metadata?.content?.data
        : [];
    },
    loading() {
      return store.state.rightPanel.loading;
    },
    titleTabs() {
      return store.state.rightPanel.metadata?.tabs?.items;
    }
  },
  methods: {
    closePanel() {
      if (this.mode == 'canditateStagePanel') {
        if (!this.titleTabs) {
          store.dispatch('rightPanel/getMetadata', {
            intentOrRequest:
              store.state.rightPanel.metadata.title.main[0].intents[0].request
          });
          store.commit('rightPanel/setParam', {
            name: 'panelMode',
            val: 'canditatePanel'
          });
        } else {
          store.commit('rightPanel/setParam', {
            name: 'panelMode',
            val: null
          });
        }
      } else {
        store.commit('rightPanel/setParam', {
          name: 'panelMode',
          val: this.mode == 'canditatePanel' ? null : 'canditatePanel'
        });
      }
    }
  },
  components: {
    Vacancies,
    VacancySteps,
    Button,
    Subpanel,
    Picture
  }
};
</script>
<style lang="scss" scoped>
.header {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid $grey8;
  padding: 19px 18px 19px 8px;
  width: 100%;
  justify-content: space-between;
  gap: 8px;

  &__top {
    display: flex;
    justify-content: space-between;
  }

  @media (min-width: 1313px) {
    &__button:not(.candidate-stages) {
      display: none;
    }

    &-title__text.candidate-stages {
      display: none;
    }
  }

  @media (max-width: 1312px) {
    &-title__text {
      display: none;
    }
  }

  &-title__text {
    line-height: 40px !important;
    margin-left: 16px;
  }

  &__button {
    box-shadow: none !important;

    &:hover {
      background: $white;
      outline: none !important;
    }
  }

  &__secondary {
    display: flex;
    gap: 4px;
    align-items: center;
  }

  &__icon {
    filter: $greyPicture;
  }

  &__image {
    filter: invert(57%) sepia(10%) saturate(567%) hue-rotate(169deg)
      brightness(90%) contrast(85%);
  }

  &__text {
    font-family: Roboto Medium;
    font-size: 16px;
    line-height: 24px;
    color: $grey64;
  }

  &__subpanels {
    & ::v-deep .el-tabs {
      min-height: 50px;
      padding-left: 16px;
    }
  }
}
</style>
